import type { SegmentConditionInterface } from '~/types'

export function parseSegmentConditions(conditions: SegmentConditionInterface) {
  return conditions.map((condition) => {
    const conditionArray = condition as unknown as any[]

    if (conditionArray[0] === 'engagement' && conditionArray.length > 3) {
      return conditionArray
    }

    const [type, operator, value, options] = conditionArray
    const data = [type, operator]

    const operatorHasNoValue = operator === 'empty' || operator === 'not_empty'
    let newValue = operatorHasNoValue ? null : value

    const filteredOptions = Array.isArray(options)
      ? options?.filter((opt: any) => Array.isArray(opt) && opt[1] === 'between')
      : []

    if (filteredOptions.length > 0) {
      newValue = filteredOptions.map((opt) => `${opt[2]},${opt[3]}`).join(',')
    }

    const modifiedOptions = Array.isArray(options)
      ? options.map((opt) => {
          if (
            Array.isArray(opt) &&
            (opt[1] === 'empty' || opt[1] === 'not_empty')
          ) {
            return [opt[0], opt[1], null]
          }

          if (Array.isArray(opt) && opt[1] === 'between') {
            const formatted = String(newValue)
              .split(',')
              .map((dateStr: any) => {
                return dateStr.trim()
                //
                // // Check if it's a full Date string (very basic check)
                // const isFullDate =
                //   /\w{3} \w{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4}/.test(
                //     trimmed,
                //   )

                // return trimmed
              })
              .join(',')

            return [opt[0], opt[1], formatted]
          }

          return opt
        })
      : []

    if (typeof value === 'object' && 'id' in value && type === 'event') {
      data.push(value.id)

      if (modifiedOptions?.length) {
        data.push(modifiedOptions.flat(2))
      }
    } else {
      if (modifiedOptions?.length && type === 'event') {
        data.push(newValue, modifiedOptions)
      } else if (options != null) {
        newValue =
          operator === 'between' && conditionArray[4] != null
            ? `${value},${conditionArray[4]}`
            : newValue
        data.push(newValue, options)
      } else {
        data.push(newValue)
      }
    }

    return data.flat(3)
  })
}
